import { useState } from 'react';

const faqs = [
  {
    q: '虫虫漫画怎么按分类找漫画？',
    a: '打开首页顶部的「题材分类速览」，或直接进入国漫频道与日漫频道，即可按玄幻、武侠、都市、科幻等题材筛选，快速找到你感兴趣的作品。',
  },
  {
    q: '国漫和日漫分别怎么浏览？',
    a: '顶部导航提供「国漫」与「日漫」两个独立频道，每个频道都支持按题材筛选和按人气、评分、更新时间排序，方便你一站式逛完对应分类。',
  },
  {
    q: '为什么有的漫画显示「连载中」，有的显示「已完结」？',
    a: '连载中的作品会持续更新最新章节，我们会在「今日新更」板块展示最新进度；已完结的作品则收录全部章节，可以放心追到底。',
  },
  {
    q: '人气、评分这些数据代表什么？',
    a: '人气反映作品的阅读热度，评分综合了读者口碑与内容质量，两者结合可以帮助你快速判断一部漫画是否值得入坑。',
  },
  {
    q: '想看的新漫画没找到，该怎么办？',
    a: '我们持续收录热门连载与经典作品。如果暂时没找到心仪的作品，可以通过网站顶部的搜索框或联系我们反馈，我们会优先补充对应分类内容。',
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);
  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-3xl px-4 md:px-6 py-12 md:py-16">
        <div className="text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            常见<span className="text-primary-500">问题</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-500">关于虫虫漫画的使用指南，或许能解答你的疑问</p>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((f, i) => (
            <div key={f.q} className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
              <button
                type="button"
                onClick={() => setOpen(open === i ? -1 : i)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                aria-expanded={open === i}
              >
                <span className="font-medium text-foreground-900">{f.q}</span>
                <i className={`shrink-0 text-lg text-primary-500 transition-transform ${open === i ? 'rotate-45' : ''}`}>
                  {open === i ? 'ri-add-line' : 'ri-add-line'}
                </i>
              </button>
              {open === i && <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600">{f.a}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}